
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, string_type, int32_type, option_type, class_type, list_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection } from "../Shared/Category.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, LabelId_$reflection, RequestedValue$1_$reflection } from "../Shared/Shared.js";
import { SavedAvailabilityView_$reflection, CategoryAvailabilityDto_$reflection } from "../Shared/Availability.js";

export class ResultViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Timeline", "Table"];
    }
}

export function ResultViewMode_$reflection() {
    return union_type("AvailabilityCheck.Types.ResultViewMode", [], ResultViewMode, () => [[], []]);
}

export class State extends Record {
    constructor(Categories, SelectedCategoryIds, StartDate, EndDate, SelectedPeriodDays, Availability, ViewMode, StatusFilter, SavedViews, PendingViewName, SaveDialogIsOpen, ManageDialogIsOpen, ViewToDelete, SaveViewName, SaveViewPeriodDays, FormState) {
        super();
        this.Categories = Categories;
        this.SelectedCategoryIds = SelectedCategoryIds;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.SelectedPeriodDays = SelectedPeriodDays;
        this.Availability = Availability;
        this.ViewMode = ViewMode;
        this.StatusFilter = StatusFilter;
        this.SavedViews = SavedViews;
        this.PendingViewName = PendingViewName;
        this.SaveDialogIsOpen = SaveDialogIsOpen;
        this.ManageDialogIsOpen = ManageDialogIsOpen;
        this.ViewToDelete = ViewToDelete;
        this.SaveViewName = SaveViewName;
        this.SaveViewPeriodDays = SaveViewPeriodDays;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("AvailabilityCheck.Types.State", [], State, () => [["Categories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["SelectedCategoryIds", list_type(LabelId_$reflection())], ["StartDate", option_type(class_type("System.DateTime"))], ["EndDate", option_type(class_type("System.DateTime"))], ["SelectedPeriodDays", option_type(int32_type)], ["Availability", option_type(CategoryAvailabilityDto_$reflection())], ["ViewMode", ResultViewMode_$reflection()], ["StatusFilter", option_type(string_type)], ["SavedViews", RequestedValue$1_$reflection(list_type(SavedAvailabilityView_$reflection()))], ["PendingViewName", option_type(string_type)], ["SaveDialogIsOpen", bool_type], ["ManageDialogIsOpen", bool_type], ["ViewToDelete", option_type(string_type)], ["SaveViewName", string_type], ["SaveViewPeriodDays", option_type(int32_type)], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CategoriesFetched", "SetCategories", "SetStartDate", "SetEndDate", "SetPeriodPreset", "FetchAvailability", "AvailabilityFetched", "SetViewMode", "ToggleStatusFilter", "SavedViewsFetched", "OpenSaveDialog", "CloseSaveDialog", "OpenManageDialog", "CloseManageDialog", "SetSaveViewName", "SetSaveViewPeriodDays", "SaveView", "RequestDeleteView", "CancelDeleteView", "ConfirmDeleteView", "ViewsSaved", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("AvailabilityCheck.Types.Msg", [], Msg, () => [[["Item", list_type(Label_$reflection())]], [["Item", list_type(LabelId_$reflection())]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", int32_type]], [], [["Item", CategoryAvailabilityDto_$reflection()]], [["Item", ResultViewMode_$reflection()]], [["Item", string_type]], [["Item", list_type(SavedAvailabilityView_$reflection())]], [], [], [], [], [["Item", string_type]], [["Item", option_type(int32_type)]], [], [["Item", string_type]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

